import fetch from '../fetch';

import {
  GROWTH_RULE_LIST,
  GROWTH_RULE_DETAIL,
  ENABLE_GROWTH_RULE,
  ADD_GROWTH_RULE,
  EDIT_GROWTH_RULE,
  GROWTH_UPDATE_LIST,
  USER_GROWTH_LIST,
  USER_GROWTH_LIST_BYMOBILE,
  EDIT_USER_GROWTH,
  GRWTH_EDIT_LIST
} from '../url';

// 查询成长规则列表
function getGrowthRuleList(data) {
  return fetch({
    url: GROWTH_RULE_LIST,
    method: 'post',
    data: data
  });
}

// 查询成长规则详情
function getGrowthRuleDetail(data) {
  return fetch({
    url: GROWTH_RULE_DETAIL,
    method: 'get',
    params: data
  });
}

// 修改成长规则状态（启用/停用）
function changeGrowthRuleStatus(data) {
  return fetch({
    url: ENABLE_GROWTH_RULE,
    method: 'post',
    data: data
  });
}

// 添加成长规则
function addGrowthRule(data) {
  return fetch({
    url: ADD_GROWTH_RULE,
    method: 'post',
    data: data,
    isNoMsg: true
  });
}

// 编辑成长规则
function editGrowthRule(data) {
  return fetch({
    url: EDIT_GROWTH_RULE,
    method: 'post',
    data: data,
    isNoMsg: true
  });
}

// 查询成长值流水列表
function getGrowthUpdateList(data) {
  return fetch({
    url: GROWTH_UPDATE_LIST,
    method: 'post',
    data: data,
    isNoMsg: true
  });
}

// 查询会员成长值列表-弃用
function getUserGrowthList(data) {
  return fetch({
    url: USER_GROWTH_LIST,
    method: 'get',
    params: data
  });
}

// 查询会员成长值列表-通过手机号查找
function getUserGrowthListByMobile(data) {
  return fetch({
    url: USER_GROWTH_LIST_BYMOBILE,
    method: 'get',
    params: data
  });
}

// 修改会员成长值
function editUserGrowth(data) {
  return fetch({
    url: EDIT_USER_GROWTH,
    method: 'post',
    data: data
  });
}

// 查询会员成长值修改记录列表
function getGrowthEditList(data) {
  return fetch({
    url: GRWTH_EDIT_LIST,
    method: 'post',
    data: data,
    isNoMsg: true
  });
}

const growth = {
  getGrowthRuleList,
  getGrowthRuleDetail,
  changeGrowthRuleStatus,
  addGrowthRule,
  editGrowthRule,
  getGrowthUpdateList,
  getUserGrowthList,
  getUserGrowthListByMobile,
  editUserGrowth,
  getGrowthEditList
};

export { growth };
